import { render, staticRenderFns } from "./NoticeBoard.vue?vue&type=template&id=579d5759&scoped=true"
import script from "./NoticeBoard.vue?vue&type=script&lang=js"
export * from "./NoticeBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579d5759",
  null
  
)

export default component.exports